export const AUCTIONS_CATALOG_ID = window.$('script[data-auctions-catalog-id]').data('auctions-catalog-id');
export const FINISHED_STATES = { SOLD: 'sold', SOLD_CONDITIONALLY: 'sold_conditionally', UNSOLD: 'unsold' };
export const UNPUBLISHED_STATUS = 'unpublished';
export const LIVE_TYPE = 'live';
export const INTERNET_TYPE = 'internet';



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show/consts.js